'use client';

import { Link, navigate } from 'gatsby';
import React, { type FC, type HTMLAttributes } from 'react';

import { combineLinkWithParameters } from '@/utils/combine-link-with-parameters';

interface ParamLinkProps extends HTMLAttributes<HTMLAnchorElement> {
    to: string;
}

export const ParamLink: FC<ParamLinkProps> = (props) => {
    return (
        <Link
            {...props}
            onClick={(event) => {
                event.preventDefault();
                navigate(combineLinkWithParameters(event.currentTarget.pathname));
            }}
        />
    );
};
